export default "__VITE_ASSET__C5bhw9TI__"